export default __webpack_public_path__ + "static/media/arrow.8961c2a1.svg";